import { Tooltip, TooltipProps } from "@mui/material"

interface IStyledTooltipProps extends TooltipProps {}

const StyledTooltip: React.FC <IStyledTooltipProps> = (props) => {
    return (
        <Tooltip {...props}>
            {props.children}
        </Tooltip>
    )
}

export default StyledTooltip